import { SETUP_ITEMS, type OnboardingStep } from "../pages/agentur/einstellungen/model";
import { t } from "./sprache";

/**
 * Probelauf H1: Eine halb eingerichtete Agentur hat keine Einstellungszeile oder es fehlen Pflichtwerte (Fachlogik wirft
 * `SETTING_MISSING: default_commission_bp`). Das ist kein Fehler der Seite, sondern ein offener Einrichtungsschritt: Die
 * Seiten zeigen dann einen Hinweis mit Link zur Einrichtung statt „Wird geladen …“ oder einer Fehlermeldung.
 */
export class EinrichtungFehlt extends Error {
  constructor(public readonly key: string) {
    super(`SETTING_MISSING: ${key}`);
    this.name = "EinrichtungFehlt";
  }
}

/** Offene Einrichtung aus einem Fehler (auch aus der Meldung der Fachlogik); sonst null. */
export function einrichtungsLuecke(error: unknown): { key: string; label: string; step: OnboardingStep; section: string } | null {
  const key = error instanceof EinrichtungFehlt
    ? error.key
    : /SETTING_MISSING:\s*([a-z_.]+)/.exec(error instanceof Error ? error.message : String(error ?? ""))?.[1];
  if (!key) return null;
  const item = SETUP_ITEMS[key] ?? SETUP_ITEMS[`org_settings.${key}`];
  return { key, label: item?.label ?? t("Einstellungen der Agentur", "Agency settings"), step: item?.step ?? "firma", section: item?.section ?? "firma" };
}

/** React Query: eine fehlende Einrichtung nicht wiederholen (sie behebt sich nicht von selbst), sonst einmal. */
export const retryAusserEinrichtung = (failures: number, error: unknown) => !einrichtungsLuecke(error) && failures < 1;
